import React from 'react';
import PropTypes from 'prop-types';

const Section = ({ children, className = '' }) => (
  <section className={`px-8 ${className}`}>
    <div className="max-w-7xl mx-auto">
      {children}
    </div>
  </section>
);

Section.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Section;
